interface ModalBackdropProps {
  children: React.ReactNode;
  onClose: () => void;
}

export const ModalBackdrop = ({ children, onClose }: ModalBackdropProps) => (
  <div
    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    onClick={onClose}
    role="presentation"
  >
    <div
      className="bg-white rounded-lg p-6 w-96"
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
    >
      {children}
    </div>
  </div>
);
